export const SEAL_NETWORK = {
    UNAUTHORIZED: 'UNAUTHORIZED',
    ERROR: 'ERROR',
    SERVER_DOWN_ERROR: 'SERVER_DOWN_ERROR',
    NO_SERVER_ERROR: 'NO_SERVER_ERROR',
    ERROR_MESSAGE: 'NETWORK_ERROR_MESSAGE'
};

export const AUTHENTICATION = {
    SIGNED_IN: 'SIGNED_IN',
    LOGIN_REQUEST: 'USER_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USER_LOGIN_FAILURE',
    LOGOUT_REQUEST: 'USER_LOGOUT_REQUEST',
    LOGOUT_SUCCESS: 'USER_LOGOUT_SUCCESS',
    LOGOUT_FAILURE: 'USER_LOGOUT_FAILURE',
    UPDATE_USERS_USERVIEWS: 'UPDATE_USERS_USERVIEWS',
    SSO_REQUEST: 'SSO_REQUEST',
    SSO_SUCCESS: 'SSO_SUCCESS',
    SSO_FAILURE: 'SSO_FAILURE',
    FETCH_PERMISSIONS_SUCCESS: 'FETCH_PERMISSIONS_SUCCESS',
    SET_SEAL_VERSION: 'SET_SEAL_VERSION',
    GET_VERSION_FAILURE: 'GET_VERSION_FAILURE',
    MOCK_VERSION_NOT_SET: 'MOCK_VERSION_NOT_SET',
    UN_MOCK_SEAL_VERSION: 'UN_MOCK_SEAL_VERSION',
    SET_MOCK_VERSION: 'SET_MOCK_VERSION',
    SET_BETA_FEATURE: 'SET_BETA_FEATURE',
    REMOVE_BETA_FEATURE: 'REMOVE_BETA_FEATURE',
    CLEAR_BETA_FEATURES: 'CLEAR_BETA_FEATURES',
    TOGGLE_RELEASE_DIALOG: 'TOGGLE_RELEASE_DIALOG',
    CLEAR_ERROR: 'CLEAR_ERROR'
};

export const DOCUMENT_IMPORT = {
    IMPORT_SUCCESS: 'DOCUMENT_IMPORT_SUCCESS',
    IMPORT_REQUEST: 'DOCUMENT_IMPORT_REQUEST',
    IMPORT_FAILURE: 'DOCUMENT_IMPORT_FAILURE',
    IMPORT_ERROR: 'DOCUMENT_IMPORT_ERROR'
};
export const DOCUMENT_METADATA = {
    FETCH_METADATA_REQUEST: 'FETCH_METADATA_REQUEST',
    FETCH_METADATA_SUCCESS: 'FETCH_METADATA_SUCCESS',
    FETCH_METADATA_FAILURE: 'FETCH_METADATA_FAILURE',
    FETCH_METADATA_CANCELLED: 'FETCH_METADATA_CANCELLED',
    FETCH_METADATA_ERROR: 'FETCH_METADATA_ERROR',
    SWITCH_SYSTEM: 'SWITCH_SYSTEM'
};

export const DOCUMENT_MARKUP = {
    BASE64_DATA: 'BASE64_DATA',
    BACKGROUND_PROCESS_SCORECARD: 'BACKGROUND_PROCESS_SCORECARD',
    BACKGROUND_PROCESS_LABELS: 'BACKGROUND_PROCESS_LABELS',
    CLEAR_BACKGROUND_PROCESS_DATA: 'CLEAR_BACKGROUND_PROCESS_DATA',
    MARKUP_PROGRESS: 'MARKUP_PROGRESS',
    CHECK_STALE_STATUS: 'CHECK_STALE_STATUS',
    TRACK_CHANGES: 'TRACK_CHANGES',
    MARKUP_RUNNING: 'MARKUP_RUNNING',
    MARKUP_CANCEL_FLAG: 'MARKUP_CANCEL_FLAG',
    PROCESSING_DIALOG_VISIBLE: 'PROCESSING_DIALOG_VISIBLE',
    TRACK_CHANGES_CHECKING_ENABLED: 'TRACK_CHANGES_CHECKING_ENABLED',
    MARKUP_FAILURE: 'MARKUP_FAILURE',
    CONTENT_CONTROL_SELECTED: 'CONTENT_CONTROL_SELECTED',
    OVERLAP_MAP: 'OVERLAP_MAP',
    MARKUP_DETAILS: 'MARKUP_DETAILS',
    TOGGLE_MARKUP_DETAILS: 'TOGGLE_MARKUP_DETAILS',
    RESET_CLICK_FLAG: 'RESET_CLICK_FLAG',
    MARKUP_EVENTS_APPLIED: 'MARKUP_EVENTS_APPLIED',
    SET_TOTAL_ITEMS: 'SET_TOTAL_ITEMS',
    SEARCH_COUNT: 'SEARCH_COUNT',
    SET_LAST_COUNT: 'SET_LAST_COUNT'
};

export const DOCUMENT_VIEWS = {
    DOCUMENT_VIEWS_REQUEST: 'DOCUMENT_VIEWS_REQUEST',
    DOCUMENT_VIEWS_SUCCESS: 'DOCUMENT_VIEWS_SUCCESS',
    DOCUMENT_VIEWS_FAILURE: 'DOCUMENT_VIEWS_FAILURE',
    CLEAR_VIEWS: 'CLEAR_VIEWS',
    CLEAR_LABELS: 'CLEAR_LABELS'
};

export const DOCUMENT_ANIMATION = {
    RUN_ANIMATION: 'RUN_ANIMATION',
    STOP_ANIMATION: 'STOP_ANIMATION',
    CANCEL_ANIMATION: 'CANCEL_ANIMATION',
    ABORT_ANIMATION: 'ABORT_ANIMATION',
    RESET_ANIMATION: 'RESET_ANIMATION'
};

export const DOCUMENT_SCORECARD = {
    FETCH_SCORECARD_REQUEST: 'FETCH_SCORECARD_REQUEST',
    FETCH_SCORECARD_SUCCESS: 'FETCH_SCORECARD_SUCCESS',
    TOGGLE_OFF_PULLING: 'TOGGLE_OFF_PULLING',
    FETCH_SCORECARD_PENDING: 'FETCH_SCORECARD_PENDING',
    FETCH_SCORECARD_FAILURE: 'FETCH_SCORECARD_FAILURE',
    FETCH_DIGAPP_REQUEST: 'FETCH_DIGAPP_REQUEST',
    FETCH_DIGAPP_SUCCESS: 'FETCH_DIGAPP_SUCCESS',
    FETCH_DIGAPP_FAILURE: 'FETCH_DIGAPP_FAILURE',
    CLEAR_SCORECARD: 'CLEAR_SCORECARD',
    CLEAR_DIGAPPS: 'CLEAR_DIGAPPS',
    UPDATE_DIGAPP: 'UPDATE_DIGAPP',
    SLE_PROCESS_STARTED: 'SLE_PROCESS_STARTED',
    UPDATE_SCORECARDS_WITH_CLAUSES_REQUEST: 'UPDATE_SCORECARDS_WITH_VALID_CLAUSES_REQUEST',
    UPDATE_SCORECARDS_WITH_CLAUSES_SUCCESS: 'UPDATE_SCORECARDS_WITH_VALID_CLAUSES_SUCCESS',
    UPDATE_SCORECARDS_WITH_CLAUSES_FAILURE: 'UPDATE_SCORECARDS_WITH_VALID_CLAUSES_FAILURE',

    ENABLE_SCORECARD_POLLING: 'ENABLE_SCORECARD_POLLING',
    DISABLE_SCORECARD_POLLING: 'DISABLE_SCORECARD_POLLING',
    REMOVE_RULELESS_DIGAPPS: 'REMOVE_RULELESS_DIGAPPS',
    RULE_STATUS_RETURNED: 'RULE_STATUS_RETURNED',
    FETCH_ANALYZERS_DETAILS: 'FETCH_ANALYZERS_DETAILS',
    TOGGLE_FAVORITE: 'TOGGLE_FAVORITE',
    MIXPANEL_DATA: 'MIXPANEL_DATA_SCORECARD'
};

export const DOCUMENT_SEARCH = {
    SEARCH_REQUEST: 'SEARCH_REQUEST',
    SEARCH_SUCCESS: 'SEARCH_SUCCESS',
    SEARCH_FAILURE: 'SEARCH_FAILURE',
    SEARCH_INDEX_CLEAR: 'SEARCH_INDEX_CLEAR',
    COUNT_REQUEST: 'SEARCH_COUNT_REQUEST',
    COUNT_SUCCESS: 'SEARCH_COUNT_SUCCESS',
    COUNT_FAILURE: 'SEARCH_COUNT_FAILED'
};
export const DOCUMENT_CONTENT_CONTROL = {
    CREATE_REQUEST: 'CREATE_REQUEST',
    CREATE_SUCCESS: 'CREATE_SUCCESS',
    CREATE_FAILURE: 'CREATE_FAILURE',
    DELETE_REQUEST: 'DELETE_REQUEST'
};

export const LABELS = {
    MIXPANEL_DATA: 'MIXPANEL_DATA_LABELS'
};

export const CLEAR_ERRORS = 'CLEAR_ERROR';
export const NOTIFICATION_HANDLER = {
    DISMISS_ERROR: 'DISMISS_ERROR',
    INFO: 'INFO',
    WARNING: 'WARNING',
    ERROR: 'ERROR',
    DISPLAY_ERROR: 'DISPLAY_ERROR'
};

export const CLAUSE_LIBRARY = {
    FETCH_LIBRARY_REQUEST: 'FETCH_LIBRARY_REQUEST',
    FETCH_LIBRARY_SUCCESS: 'FETCH_LIBRARY_SUCCESS',
    FETCH_LIBRARY_FAILED: 'FETCH_LIBRARY_FAILED',
    FETCH_LIBRARY_TOKEN_EXPIRED: 'FETCH_LIBRARY_TOKEN_EXPIRED',
    NO_PERMISSIONS: 'CLAUSE_NO_PERMISSIONS',
    CLAUSE_PREVIEW: 'CLAUSE_PREVIEW',
    REFRESH_LIBRARY_UI: 'CLAUSE_REFRESH_UI',
    CLEAR_CLAUSE_LIBRARY: 'CLEAR_CLAUSE_LIBRARY',
    INDEXING_CLAUSES_START: 'INDEXING_CLAUSES_START',
    INDEXING_CLAUSES_SUCCESS: 'INDEXING_CLAUSES_SUCCESS',
    INDEXING_CLAUSES_FAILED: 'INDEXING_CLAUSES_FAILED',
    MIXPANEL_DATA: 'MIXPANEL_DATA_CLAUSE_LIBRARY',
    SET_DRAWER_OPEN_STATE: 'SET_DRAWER_OPEN_STATE'
};

export const NOTIFICATION = {
    FILE_SIZE: 'NOTIFICATION_FILE_SIZE'
};

export const NAVIGATION = {
    HEADER_MENU_TOGGLE: 'HEADER_MENU_TOGGLE',
    CURRENT_TAB: 'CURRENT_TAB',
    PAGE_LOADED: 'PAGE_LOADED'
};

export const BASE_LAYOUT_RERENDER = 'BASE_LAYOUT_RERENDER';

export const SEAL_SYSTEMS = {
    SEAL_SYSTEM_UPDATE: 'SEAL_SYSTEM_UPDATE',
    SEAL_SYSTEM_REMOVE: 'SEAL_SYSTEM_REMOVE',
    SEAL_SYSTEMS_REMOVE_ALL: 'SEAL_SYSTEMS_REMOVE_ALL',
    SEAL_SYSTEMS_UPDATE_ALL: 'SEAL_SYSTEMS_UPDATE_ALL',
    SSO_CHECK: 'SSO_CHECK',
    SSO_CONFIGURED: 'SSO_CONFIGURED',
    SSO_NOT_CONFIGURED: 'SSO_NOT_CONFIGURED'
};

export const CONTRACT_SEARCH = {
    SEARCH_REQUESTED: 'CONTRACT_SEARCH_REQUESTED',
    SEARCH_SUCCESS: 'CONTRACT_SEARCH_SUCCESS',
    SEARCH_FAILURE: 'CONTRACT_SEARCH_FAILURE',
    NO_PERMISSIONS: 'CONTRACT_SEARCH_NO_PERMISSIONS',
    TOKEN_EXPIRED: 'CONTRACT_SEARCH_TOKEN_EXPIRED',
    SEARCH_CLEAR: 'CONTRACT_SEARCH_CLEAR',
    SEARCH_NEXT_PAGE: 'CONTRACT_SEARCH_NEXT_PAGE',
    SEARCH_PREV_PAGE: 'CONTRACT_SEARCH_PREV_PAGE',
    EXPORTED_DOCX_SUCCESS: 'CONTRACT_EXPORTED_DOCX_SUCCESS',
    EXPORTED_DOCX_FAILED: 'CONTRACT_EXPORTED_DOCX_FAILED',
    GENERATE_PERMA_LINK_SUCCESS: 'GENERATE_PERMA_LINK_SUCCESS',
    GENERATE_PERMA_LINK_FAILED: 'GENERATE_PERMA_LINK_FAILED',
    FETCH_CONTRACTS_PARTIES_SUCCESS: 'FETCH_CONTRACTS_PARTIES_SUCCESS',
    FETCH_CONTRACTS_PARTIES_FAILED: 'FETCH_CONTRACTS_PARTIES_FAILED',
    UPLOADED_BY_USER_SUCCESS: 'UPLOADED_BY_USER_SUCCESS',
    UPLOADED_BY_USER_FAILED: 'UPLOADED_BY_USER_FAILED',
    CLEAR_SELECTED_CONTRACT: 'CONTRACT_SEARCH_CLEAR_SELECTION',
    FETCH_SELECTED_CONTRACT_REQUESTED: 'FETCH_SELECTED_CONTRACT_REQUESTED',
    SELECT_CONTRACT: 'SELECT_CONTRACT',
    GET_DOCX_DOWNLOAD_PATH_SUCCESS: 'GET_DOCX_DOWNLOAD_PATH_SUCCESS',
    GET_DOCX_DOWNLOAD_PATH_FAILED: 'GET_DOCX_DOWNLOAD_PATH_FAILED',
    EXPORTED_DOCX_GENERATION_REQUESTED: 'EXPORTED_DOCX_GENERATION_REQUESTED',
    EXPORTED_DOCX_GENERATION_SUCCESS: 'EXPORTED_DOCX_GENERATION_SUCCESS',
    EXPORTED_DOCX_GENERATION_ERROR: 'EXPORTED_DOCX_GENERATION_ERROR',
    EXPORTED_DOCX_GENERATION_RESET: 'EXPORTED_DOCX_GENERATION_RESET',
    SEARCH_CRITERIA: 'SEARCH_CRITERIA'
};
export const FILTERS = {
    SET_TOPICS: 'SET_TOPICS',
    SET_SUBTOPICS: 'SET_SUBTOPICS',
    SET_RISK_LEVELS: 'SET_RISK_LEVELS',
    SET_SORTING: 'SET_SORTING',
    FILTER_BY_TOPICS: 'FILTER_BY_TOPICS',
    FILTER_BY_SUBTOPICS: 'FILTER_BY_SUBTOPICS',
    FILTER_BY_RISK_LEVELS: 'FILTER_BY_RISK_LEVELS',
    FILTER_BY_ANSWERS: 'FILTER_BY_ANSWERS',
    FILTER_BY_SUGGESTED_CLAUSES: 'FILTER_BY_SUGGESTED_CLAUSES',
    FILTER_BY_EXTRACTIONS: 'UPDATE_EXTRACTIONS',
    UPDATE_SORTING: 'UPDATE_SORTING',
    RESET_FILTERS: 'RESET_FILTERS'
};

export const MIX_PANEL = {
    MIXPANEL_DATA_CLAUSE_LIBRARY: 'MIXPANEL_DATA_CLAUSE_LIBRARY',
    MIXPANEL_DATA_SCORECARD: 'MIXPANEL_DATA_SCORECARD',
    MIXPANEL_DATA_SCORECARD_STEP_TIME: 'SCORECARD_STEP_TIME',
    MIXPANEL_DATA_LABELS: 'MIXPANEL_DATA_LABELS',
    MIXPANEL_DATA_MARKUP: 'MIXPANEL_DATA_MARKUP',
    MIXPANEL_DATA_CONTRACTS: 'MIXPANEL_DATA_CONTRACTS'
};
